import { APP_RETIREMENT_URLS } from "../../../const/AppConst"
import InfoBeneficiaryTemplate from "../../../components/info-beneficiary-template/InfoBeneficiaryTemplate";
import useAppState from "../../../context/AppContext";


export default function REInfoBeneficiaryBloc() {
  const {
    state: { proposition }
  } = useAppState();

  const nextUrl = proposition?.configuration?.requireIdentityDocument 
                    ? APP_RETIREMENT_URLS.infoIdentityDocPage 
                    : APP_RETIREMENT_URLS.infoRetirementDocPage;
  return (
    <form style={{width: '100%'}} className="bg-blanc p-lg">
        <h2 className="card-title bleu">Je souhaite ajouter mes ayants droit</h2>
        <p className="text mt-sm mb-md">Cette liste d'ayants droit est établie à partir des attestations téléchargées. Veuillez modifier les informations incorrectes ou retirer les ayants droit que vous ne souhaitez pas couvrir.</p>
        <div className='form-row page-content'>
            <InfoBeneficiaryTemplate nextUrl={nextUrl} previousUrl={APP_RETIREMENT_URLS.infoAttestationROBeneficiaryPage}/>
        </div>
   
    </form>
  )
}